import { useState, useEffect, useContext, useRef } from "react";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Link } from "react-router-dom";
import HeaderDashboard from "../../Components/HeaderDashboard";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { AuthContext } from "../../Routes/AuthProvider";
import { getAllHotelBookings } from "../../Services/HotelSearchApi";

const AllTransactions = () => {
  const { userName, roles } = useContext(AuthContext);
  const isCorpTravel = roles?.includes("Corporate Traveller");

  const tableWrapperRef = useRef(null);

  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    bookingRefNo: "",
    bookingStatus: "",
    paymentStatus: "",
    hotelName: "",
    hotelPNR: "",
  });

  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [filterText, setFilterText] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const convertToDate = (str) => {
    if (!str) return null;
    const [day, month, year] = str.split("/");
    return new Date(`${year}-${month}-${day}`);
  };

  const formatDateForApi = (dateStr, isEnd = false) => {
    if (!dateStr) return undefined;
    const dateObj = convertToDate(dateStr);
    if (!dateObj || isNaN(dateObj.getTime())) return undefined;

    const pad = (num) => String(num).padStart(2, '0');
    const year = dateObj.getFullYear();
    const month = pad(dateObj.getMonth() + 1);
    const day = pad(dateObj.getDate());
    const hours = isEnd ? "23" : "00";
    const minutes = isEnd ? "59" : "00";
    const seconds = isEnd ? "59" : "00";
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    $("#fromDate").datepicker({
      dateFormat: "dd/mm/yy",
      maxDate: 0,
      onSelect: function (dateText) {
        setFilters((prev) => ({
          ...prev,
          fromDate: dateText,
        }));
      },
    });

    $("#toDate").datepicker({
      dateFormat: "dd/mm/yy",
      maxDate: 0,
      onSelect: function (dateText) {
        setFilters((prev) => ({
          ...prev,
          toDate: dateText,
        }));
      },
    });
  }, []);

  useEffect(() => {
    if (filters.fromDate) {
      const minD = convertToDate(filters.fromDate);
      $("#toDate").datepicker("option", "minDate", minD);
    }
  }, [filters.fromDate]);

  const handleSearch = async () => {
    setLoading(true);
    setHasSearched(true);
    try {
      const fromDateParam = formatDateForApi(filters.fromDate, false);
      const toDateParam = formatDateForApi(filters.toDate, true);
      const data = await getAllHotelBookings(
        userName,
        filters.bookingStatus,
        filters.paymentStatus,
        fromDateParam,
        toDateParam,
        filters.hotelPNR,
        filters.bookingRefNo,
        filters.hotelName
      );

      let list = [];
      if (Array.isArray(data)) {
        list = data;
      } else if (data?.bookings && Array.isArray(data.bookings)) {
        list = data.bookings;
      } else if (
        data?.data?.allHotelBookings &&
        Array.isArray(data.data.allHotelBookings)
      ) {
        list = data.data.allHotelBookings;
      } else if (data?.data && Array.isArray(data.data)) {
        list = data.data;
      } else if (data?.allTransactions && Array.isArray(data.allTransactions)) {
        list = data.allTransactions;
      } else if (
        data?.allHotelBookings &&
        Array.isArray(data.allHotelBookings)
      ) {
        list = data.allHotelBookings;
      } else if (
        data?.data?.allTransactions &&
        Array.isArray(data.data.allTransactions)
      ) {
        list = data.data.allTransactions;
      }

      console.log("Extracted List:", list);

      // Apply client-side filters
      if (filters.bookingRefNo) {
        list = list.filter((item) => {
          const ref = (
            item.bookingRefId ||
            item.BookingRefId ||
            item.confirmationNo ||
            item.ConfirmationNo ||
            item.referenceNo ||
            item.ReferenceNo ||
            ""
          ).toLowerCase();
          return ref.includes(filters.bookingRefNo.toLowerCase());
        });
      }
      if (filters.hotelPNR) {
        list = list.filter((item) => {
          const pnr = (
            item.hotelPNR ||
            item.HotelPNR ||
            item.confirmationNo ||
            item.ConfirmationNo ||
            item.pnr ||
            item.PNR ||
            ""
          ).toLowerCase();
          return pnr.includes(filters.hotelPNR.toLowerCase());
        });
      }
      if (filters.hotelName) {
        list = list.filter((item) => {
          const hotel = (item.hotelName || item.HotelName || "").toLowerCase();
          const city = (item.cityName || item.CityName || "").toLowerCase();
          const search = filters.hotelName.toLowerCase();
          return hotel.includes(search) || city.includes(search);
        });
      }
      if (filters.bookingStatus) {
        list = list.filter((item) => {
          const status = (item.bookingStatus || item.BookingStatus || "").toUpperCase();
          return status === filters.bookingStatus.toUpperCase();
        });
      }
      if (filters.paymentStatus) {
        list = list.filter((item) => {
          const status = (item.paymentStatus || item.PaymentStatus || "").toUpperCase();
          return status === filters.paymentStatus.toUpperCase();
        });
      }
      if (filters.fromDate || filters.toDate) {
        const fromLimit = filters.fromDate ? convertToDate(filters.fromDate) : null;
        if (fromLimit) fromLimit.setHours(0, 0, 0, 0);

        const toLimit = filters.toDate ? convertToDate(filters.toDate) : null;
        if (toLimit) toLimit.setHours(23, 59, 59, 999);

        list = list.filter((item) => {
          const itemDateStr = item.createdAt || item.CreatedAt || item.bookingDate || item.BookingDate;
          if (!itemDateStr) return false;
          const itemDate = new Date(itemDateStr);
          if (isNaN(itemDate.getTime())) return false;

          if (fromLimit && itemDate < fromLimit) return false;
          if (toLimit && itemDate > toLimit) return false;
          return true;
        });
      }

      setTransactions(list);
    } catch (error) {
      console.error("Error fetching hotel transactions:", error);
      alert("Failed to fetch transactions. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userName) {
      handleSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userName]);

  const formatDateTimeDisplay = (dateStr) => {
    if (!dateStr) return "-";
    try {
      const date = new Date(dateStr);
      return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (e) {
      return dateStr;
    }
  };

  const formatDateShort = (dateStr) => {
    if (!dateStr) return "-";
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch (e) {
      return dateStr;
    }
  };

  // Get Pax Name from nested rooms
  const getPaxName = (item) => {
    const rooms = item.rooms || item.Rooms || [];
    const names = [];
    rooms.forEach((room) => {
      const paxDetails = room.paxDetails || room.PaxDetails || [];
      paxDetails.forEach((pax) => {
        const title = pax.title || pax.Title || "";
        const first = pax.firstName || pax.FirstName || "";
        const last = pax.lastName || pax.LastName || "";
        const full = [title, first, last].filter(Boolean).join(" ").trim();
        if (full) names.push(full);
      });
    });
    if (names.length > 0) return names.join(", ");
    return (
      item.guestName || item.GuestName ||
      item.paxName || item.PaxName ||
      item.passengerName || item.PassengerName ||
      item.leadPassenger || item.LeadPassenger ||
      item.Passenger || item.passenger ||
      "-"
    );
  };

  const filteredItems = transactions.filter((item) => {
    if (!filterText) return true;
    const term = filterText.toLowerCase();
    const ref = (
      item.bookingRefId ||
      item.BookingRefId ||
      item.referenceNo ||
      item.ReferenceNo ||
      ""
    ).toLowerCase();
    const status = (item.bookingStatus || item.BookingStatus || "").toLowerCase();
    const conf = (item.confirmationNo || item.ConfirmationNo || "").toLowerCase();
    const pnr = (item.hotelPNR || item.HotelPNR || item.pnr || item.PNR || "").toLowerCase();
    const hotel = (item.hotelName || item.HotelName || "").toLowerCase();
    const city = (item.cityName || item.CityName || "").toLowerCase();
    const entity = (item.gstName || "").toLowerCase();
    const paxName = getPaxName(item).toLowerCase();
    return (
      ref.includes(term) ||
      status.includes(term) ||
      conf.includes(term) ||
      pnr.includes(term) ||
      hotel.includes(term) ||
      city.includes(term) ||
      entity.includes(term) ||
      paxName.includes(term)
    );
  });

  // Status Badge Component
  const StatusBadge = ({ status, type = "booking" }) => {
    let bg = "#ffe5e5";
    let color = "#ff1f1f";

    if (type === "payment") {
      const upperStatus = (status || "").toUpperCase();
      if (upperStatus === "SUCCESS") {
        bg = "#e7f8ec";
        color = "#00a63e";
      } else if (["REQUESTED", "REFUNDED", "UNPAID"].includes(upperStatus)) {
        bg = "#fff3d6";
        color = "#ff9800";
      } else if (upperStatus === "FAILED") {
        bg = "#ffe5e5";
        color = "#ff1f1f";
      } else {
        bg = "#f0f0f0";
        color = "#666";
      }
    } else {
      const upperStatus = (status || "").toUpperCase();
      if (upperStatus === "CONFIRMED") {
        bg = "#e7f8ec";
        color = "#00a63e";
      } else if (["PENDING", "HOLD", "CANCELLATION_PENDING", "APPROVE_PENDING"].includes(upperStatus)) {
        bg = "#fff3d6";
        color = "#ff9800";
      } else if (["FAILED", "CANCELLED", "APPROVE_REJECTED"].includes(upperStatus)) {
        bg = "#ffe5e5";
        color = "#ff1f1f";
      } else {
        bg = "#f0f0f0";
        color = "#666";
      }
    }

    return (
      <span
        style={{
          background: bg,
          color: color,
          padding: "6px 12px",
          borderRadius: "30px",
          fontSize: "12px",
          fontWeight: "600",
          display: "inline-block",
          minWidth: "85px",
          textAlign: "center",
        }}
      >
        {status || "-"}
      </span>
    );
  };

  // DataTable Columns Definition - Same sequence as hotel original
  const allColumns = [
    {
      id: "referenceNo",
      name: "Ref No.",
      selector: row => row.bookingRefId || row.BookingRefId || row.referenceNo || row.ReferenceNo || "",
      sortable: true,
      cell: row => (
        <Link
          to={`/reservations/hotel/TransactionsDetails?referenceno=${row.bookingRefId || row.BookingRefId || row.referenceNo || row.ReferenceNo}`}
          style={{
            color: "#0d47a1",
            fontWeight: "600",
            cursor: "pointer",
            textDecoration: "none"
          }}
        >
          {row.bookingRefId || row.BookingRefId || row.referenceNo || row.ReferenceNo || "-"}
        </Link>
      ),
      priority: 1,
    },
    ...(!isCorpTravel ? [
      {
        id: "entityName",
        name: "Entity Name",
        selector: row => row.gstName || "-",
        sortable: true,
        grow: 2,
        cell: row => row.gstName || "-",
        priority: 2,
      },
      {
        id: "paxName",
        name: "Pax Name",
        selector: row => getPaxName(row),
        sortable: true,
        grow: 2,
        cell: row => getPaxName(row),
        priority: 3,
      }
    ] : []),
    {
      id: "bookingDate",
      name: "Booking Date",
      selector: row => row.createdAt || row.CreatedAt || row.bookingDate || row.BookingDate || "",
      sortable: true,
      priority: 4,
      grow: 2,
      cell: row => formatDateTimeDisplay(row.createdAt || row.CreatedAt || row.bookingDate || row.BookingDate),
    },
    {
      id: "city",
      name: "City",
      selector: row => row.cityName || "-",
      sortable: true,
      cell: row => row.cityName || "-",
    },
    {
      id: "hotelName",
      name: "Hotel",
      selector: row => row.hotelName || "-",
      sortable: true,
      grow: 2,
      cell: row => row.hotelName || "-",
    },
    {
      id: "checkIn",
      name: "Check-in",
      selector: row => row.checkInDate || "",
      sortable: true,
      cell: row => formatDateTimeDisplay(row.checkInDate),
    },
    {
      id: "checkOut",
      name: "Check-out",
      selector: row => row.checkOutDate || "",
      sortable: true,
      cell: row => formatDateTimeDisplay(row.checkOutDate),
    },
    {
      id: "rooms",
      name: "Room",
      selector: row => row.noOfRooms || "-",
      sortable: true,
      cell: row => row.noOfRooms || "-",
    },
    {
      id: "pnr",
      name: "PNR",
      selector: row => row.hotelPNR || row.confirmationNo || "-",
      sortable: true,
      cell: row => row.hotelPNR || row.confirmationNo || "-",
    },
    {
      id: "paymentStatus",
      name: "Payment",
      selector: row => row.paymentStatus || row.PaymentStatus || "-",
      sortable: true,
      cell: row => <StatusBadge status={row.paymentStatus || row.PaymentStatus || "-"} type="payment" />,
      priority: 9,
    },
    {
      id: "bookingStatus",
      name: "Booking",
      selector: row => row.bookingStatus || row.BookingStatus || "-",
      sortable: true,
      cell: row => <StatusBadge status={row.bookingStatus || row.BookingStatus || "-"} type="booking" />,
      priority: 10,
    },
    {
      id: "amount",
      name: "Amount",
      selector: row => row.totalPrice || row.TotalPrice || row.amount || row.Amount || 0,
      sortable: true,
      grow: 2,
      cell: row => (
        <span className="fw-bold">
          ₹ {(row.totalPrice || row.TotalPrice || row.amount || row.Amount || 0)?.toLocaleString()}
        </span>
      ),
    },
  ];

  // Responsive Columns Logic
  const calculateResponsiveColumns = () => {
    if (!tableWrapperRef.current) return;

    const containerWidth = tableWrapperRef.current.clientWidth;
    const expanderWidth = 45;

    const columnWidths = {
      referenceNo: 130,
      entityName: 200,
      paxName: 180,
      bookingDate: 160,
      city: 120,
      hotelName: 220,
      checkIn: 150,
      checkOut: 150,
      rooms: 80,
      pnr: 120,
      paymentStatus: 140,
      bookingStatus: 140,
      amount: 120,
    };

    let availableWidth = containerWidth - expanderWidth;
    const visible = [];
    const hidden = [];

    visible.push(allColumns[0]);
    availableWidth -= columnWidths.referenceNo || 130;

    allColumns.slice(1).forEach(column => {
      const width = columnWidths[column.id] || 120;
      if (availableWidth >= width) {
        visible.push(column);
        availableWidth -= width;
      } else {
        hidden.push(column);
      }
    });

    setVisibleColumns(visible);
    setHiddenColumns(hidden);
  };

  useEffect(() => {
    calculateResponsiveColumns();

    const resizeObserver = new ResizeObserver(() => {
      calculateResponsiveColumns();
    });

    if (tableWrapperRef.current) {
      resizeObserver.observe(tableWrapperRef.current);
    }

    window.addEventListener("resize", calculateResponsiveColumns);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", calculateResponsiveColumns);
    };
  }, [transactions]);

  const ExpandedComponent = ({ data }) => {
    return (
      <div className="expanded-data">
        {hiddenColumns.map(column => (
          <div key={column.id} className="expanded-item">
            <strong>{column.name}:</strong>
            <span>
              {column.cell ? column.cell(data) : column.selector ? column.selector(data) : "-"}
            </span>
          </div>
        ))}
      </div>
    );
  };

  // DataTable Custom Styles
  const customStyles = {
    headRow: {
      style: {
        background: "#110942",
        minHeight: "55px"
      }
    },
    headCells: {
      style: {
        color: "#fff",
        fontWeight: 600,
        fontSize: "13px"
      }
    },
    rows: {
      style: {
        minHeight: "55px",
        '&:hover': {
          backgroundColor: "#f8f9ff"
        }
      }
    }
  };

  // Excel Export
  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = now.toLocaleString("en-US", { month: "short" });
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const excelName = `HotelTransaction_Report_${day}${month}_${hours}_${minutes}`;

  const exportToExcel = (data, fileName = "Transactions") => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    worksheet["!cols"] = [
      { wch: 15 }, // Ref No
      { wch: 40 }, // Entity Name
      { wch: 35 }, // Pax Name
      { wch: 20 }, // Booking Date
      { wch: 20 }, // City
      { wch: 35 }, // Hotel
      { wch: 20 }, // Check-in
      { wch: 20 }, // Check-out
      { wch: 10 }, // Room
      { wch: 15 }, // PNR
      { wch: 15 }, // Payment
      { wch: 15 }, // Booking
      { wch: 15 }, // Amount
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(fileData, `${fileName}.xlsx`);
  };

  const exportHotelExcel = () => {
    const exportData = filteredItems.map((item) => ({
      "Ref No": item.bookingRefId || item.BookingRefId || item.referenceNo || item.ReferenceNo || "",
      "Entity Name": item.gstName || "",
      "Pax Name": getPaxName(item),
      "Booking Date": formatDateTimeDisplay(item.createdAt || item.CreatedAt || item.bookingDate || item.BookingDate),
      "City": item.cityName || "",
      "Hotel": item.hotelName || "",
      "Check-in": formatDateTimeDisplay(item.checkInDate),
      "Check-out": formatDateTimeDisplay(item.checkOutDate),
      "Room": item.noOfRooms || "",
      "PNR": item.hotelPNR || item.confirmationNo || "",
      "Payment": item.paymentStatus || item.PaymentStatus || "",
      "Booking": item.bookingStatus || item.BookingStatus || "",
      "Amount": (item.totalPrice || item.TotalPrice || item.amount || item.Amount || 0),
    }));

    exportToExcel(exportData, excelName);
  };

  // PDF Export
  // PDF Export with proper formatting
  const exportHotelPDF = () => {
    const doc = new jsPDF('landscape'); // Use landscape for more columns

    // Get current date for header
    const today = new Date();
    const dateStr = today.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });

    // Add title
    doc.setFontSize(16);
    doc.text('Hotel Transactions Report', 14, 20);
    doc.setFontSize(10);
    doc.text(`Generated: ${dateStr}`, 14, 28);

    // Format data for table
    const tableData = filteredItems.map((item) => [
      item.bookingRefId || item.BookingRefId || item.referenceNo || item.ReferenceNo || "",
      item.gstName || "",
      getPaxName(item),
      formatDateTimeDisplay(item.createdAt || item.CreatedAt || item.bookingDate || item.BookingDate),
      item.cityName || "",
      item.hotelName || "",
      formatDateShort(item.checkInDate),
      formatDateShort(item.checkOutDate),
      item.noOfRooms || "",
      item.hotelPNR || item.confirmationNo || "",
      item.paymentStatus || item.PaymentStatus || "",
      item.bookingStatus || item.BookingStatus || "",
      `₹ ${(item.totalPrice || item.TotalPrice || item.amount || item.Amount || 0).toLocaleString()}`,
    ]);

    autoTable(doc, {
      head: [[
        "Ref No",
        "Entity Name",
        "Pax Name",
        "Booking Date",
        "City",
        "Hotel",
        "Check-in",
        "Check-out",
        "Room",
        "PNR",
        "Payment",
        "Booking",
        "Amount"
      ]],
      body: tableData,
      startY: 35,
      styles: {
        fontSize: 8,
        cellPadding: 2,
        overflow: 'linebreak',
        halign: 'left',
      },
      headStyles: {
        fillColor: [17, 9, 66], // #110942
        textColor: [255, 255, 255],
        fontSize: 8,
        fontStyle: 'bold',
        halign: 'center',
      },
      columnStyles: {
        0: { cellWidth: 35 }, // Ref No
        1: { cellWidth: 45 }, // Entity Name
        2: { cellWidth: 45 }, // Pax Name
        3: { cellWidth: 35 }, // Booking Date
        4: { cellWidth: 25 }, // City
        5: { cellWidth: 45 }, // Hotel
        6: { cellWidth: 30 }, // Check-in
        7: { cellWidth: 30 }, // Check-out
        8: { cellWidth: 15 }, // Room
        9: { cellWidth: 25 }, // PNR
        10: { cellWidth: 25 }, // Payment
        11: { cellWidth: 25 }, // Booking
        12: { cellWidth: 30 }, // Amount
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
      margin: { left: 10, right: 10 },
      pageBreak: 'auto',
      rowPageBreak: 'avoid',
    });

    // Add footer with page numbers
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.text(`Page ${i} of ${pageCount}`, 14, doc.internal.pageSize.height - 10);
      doc.text('Berry Journeys | Enterprise Travel', doc.internal.pageSize.width - 50, doc.internal.pageSize.height - 10, { align: 'right' });
    }

    doc.save(excelName + ".pdf");
  };

  return (
    <>
      <style>{`
        .ui-datepicker {
          z-index: 9999 !important;
        }
        .expanded-data {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 10px;
          padding: 15px 20px;
          background: #f8f9fa;
        }
        .expanded-item {
          display: flex;
          flex-direction: column;
          padding: 5px 0;
        }
        .expanded-item strong {
          font-size: 12px;
          color: #666;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        .expanded-item span {
          font-size: 14px;
          font-weight: 500;
        }
        .table-plus-icon {
          font-size: 20px;
          font-weight: 600;
          color: #110942;
          display: inline-block;
          width: 24px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          border-radius: 4px;
          // background: #f0f0f0;
        }
        .rdt_ExpanderRow {
          background: #f8f9fa !important;
        }
      `}</style>

      <HeaderDashboard />

      <div className="toolbar py-2" id="kt_toolbar">
        <div className="container-fluid d-flex align-items-center">
          <div className="flex-grow-1">
            <div className="page-title d-flex align-items-center flex-wrap">
              <h1 className="text-gray-900 fw-bold fs-3">Reservations</h1>
              <span className="h-20px border-gray-200 border-start mx-3"></span>
              <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                <li className="breadcrumb-item text-muted">Hotel</li>
                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-200 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item text-gray-900">All Transactions</li>
              </ul>
            </div>
          </div>
          <div className="d-flex align-items-center flex-wrap">
            <div className="flex-shrink-0 me-2 d-none-mob">
              <ul className="nav" role="tablist">
                <li className="nav-item" role="presentation">
                  <a href="/Dashboard">
                    <img src="/assets/images/back.png" width={30} alt="back" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <section className="wraper">
        <div className="box_shadow mt-14">
          <div className="row g-3">
            <div className="col-md-2">
              <label className="form-label fw-bold">From Date</label>
              <input
                type="text"
                id="fromDate"
                className="form-control"
                placeholder="From Date"
                value={filters.fromDate}
                style={{ cursor: "pointer" }}
                readOnly
              />
            </div>
            <div className="col-md-2">
              <label className="form-label fw-bold">To Date</label>
              <input
                type="text"
                id="toDate"
                className="form-control"
                placeholder="To Date"
                value={filters.toDate}
                style={{ cursor: "pointer" }}
                readOnly
              />
            </div>
            <div className="col-md-4">
              <label className="form-label fw-bold">Hotel Name / City</label>
              <input
                className="form-control"
                type="text"
                name="hotelName"
                value={filters.hotelName}
                onChange={handleChange}
                placeholder="Search by hotel or city"
              />
            </div>
            <div className="col-md-4">
              <label className="form-label fw-bold">Reference No</label>
              <input
                className="form-control"
                type="text"
                name="bookingRefNo"
                value={filters.bookingRefNo}
                onChange={handleChange}
                placeholder="Ref No"
              />
            </div>

            <div className="col-md-3">
              <label className="form-label fw-bold">Booking Status</label>
              <select
                className="form-select"
                name="bookingStatus"
                value={filters.bookingStatus}
                onChange={handleChange}
              >
                <option value="">-Select-</option>
                <option value="PENDING">PENDING</option>
                <option value="CONFIRMED">CONFIRMED</option>
                <option value="HOLD">HOLD</option>
                <option value="FAILED">FAILED</option>
                <option value="CANCELLATION_PENDING">CANCELLATION_PENDING</option>
                <option value="CANCELLED">CANCELLED</option>
                <option value="APPROVE_PENDING">APPROVE_PENDING</option>
                <option value="APPROVE_REJECTED">APPROVE_REJECTED</option>
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold">Payment Status</label>
              <select
                className="form-select"
                name="paymentStatus"
                value={filters.paymentStatus}
                onChange={handleChange}
              >
                <option value="">-Select-</option>
                <option value="Success">Success</option>
                <option value="Requested">Requested</option>
                <option value="Failure">Failure</option>
                <option value="Refunded">Refunded</option>
                <option value="UnPaid">UnPaid</option>
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold">Hotel PNR</label>
              <input
                className="form-control"
                type="text"
                name="hotelPNR"
                value={filters.hotelPNR}
                onChange={handleChange}
                placeholder="Hotel PNR"
              />
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold" style={{ visibility: "hidden" }}>Search</label>
              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={handleSearch}
                disabled={loading}
              >
                {loading ? "Loading..." : "Search"}
              </button>
            </div>
          </div>
        </div>

        <div className="box_shadow mt-3">
          <div className="row mb-3">
            <div className="col-md-8 col-lg-8">
              <button
                className="btn btn-success me-2"
                onClick={exportHotelExcel}
                disabled={filteredItems.length === 0}
              >
                <i className="fa fa-file-excel"></i> Excel
              </button>
              <button
                className="btn btn-danger"
                onClick={exportHotelPDF}
                disabled={filteredItems.length === 0}
              >
                <i className="fa fa-file-pdf"></i> PDF
              </button>
            </div>
            <div className="col-md-4 ms-auto">
              <input
                type="text"
                className="form-control"
                placeholder="Search Ref No, Pax Name, PNR..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </div>
          </div>

          <div ref={tableWrapperRef} className="transaction-table-wrapper">
            <DataTable
              columns={visibleColumns}
              data={filteredItems}
              progressPending={loading}
              pagination
              paginationPerPage={10}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
              customStyles={customStyles}
              highlightOnHover
              responsive
              persistTableHead
              noDataComponent={
                !hasSearched ? (
                  <span className="text-muted">Please enter search criteria and click Search to view transactions.</span>
                ) : (
                  <span className="text-muted">No transactions found</span>
                )
              }
              expandableRows={hiddenColumns.length > 0}
              expandableRowsComponent={ExpandedComponent}
              expandOnRowClicked={false}
              expandableRowsHideExpander={false}
              expandableIcon={{
                collapsed: <span className="table-plus-icon">+</span>,
                expanded: <span className="table-plus-icon">−</span>,
              }}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default AllTransactions;
